import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";

import { Helmet } from "react-helmet";

import ProductListing from "../product-listing";
import ProductView from "../product-view";

const Index = (props) => {
    const history = useHistory();
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [newsArticles, setNewsArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeCategory, setActiveCategory] = useState(null);
    const [chartData, setChartData] = useState(null);
    const [topNews, setTopNews] = useState(null);
    const [activeSlide, setActiveSlide] = useState(0);
    const [cartCount, setCartCount] = useState(0);

    const bannerContainerStyle = {
        margin: '32px',
        height: '420px',
        borderRadius: '28px',
        overflow: 'hidden',
        position: 'relative',
        background: '#F8EFE6'
    };

    const bannerSlideStyle = {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        transition: 'all 0.6s ease-in-out'
    };

    const bannerContentStyle = {
        position: 'absolute',
        left: '60px',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 2,
        maxWidth: '420px'
    };

    const bannerButtonStyle = {
        width: '180px',
        height: '58px',
        borderRadius: '18px',
        border: 'none',
        background: '#111111',
        color: '#FFFFFF',
        fontSize: '18px',
        fontWeight: '600',
        marginTop: '32px',
        cursor: 'pointer'
    };

    const dotContainerStyle = {
        position: 'absolute',
        bottom: '24px',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        gap: '12px',
        zIndex: 5
    };

    const infoBannerContainerStyle = {
        margin: '0 32px 32px 32px',
        background: '#FFFFFF',
        border: '1px solid #EEEEEE',
        borderRadius: '24px',
        padding: '32px 40px',
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '24px'
    };

    const infoItemStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '18px'
    };

    const infoIconStyle = {
        width: '56px',
        height: '56px',
        borderRadius: '18px',
        background: '#F8F8F8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '28px'
    };

    const infoTitleStyle = {
        fontSize: '20px',
        fontWeight: '700',
        color: '#111111',
        marginBottom: '6px'
    };

    const infoSubtitleStyle = {
        fontSize: '16px',
        color: '#777777'
    };

    const infoBannerData = [
        {
            icon: '🚚',
            title: 'Free Delivery',
            subtitle: 'On orders over $50'
        },
        {
            icon: '🔄',
            title: 'Easy Returns',
            subtitle: '30-day returns'
        },
        {
            icon: '🔒',
            title: 'Secure Payment',
            subtitle: '100% protected'
        },
        {
            icon: '🎧',
            title: '24/7 Support',
            subtitle: 'We’re here to help'
        }
    ];

    const productSectionStyle = {
        padding: '0 32px 40px 32px'
    };

    const sectionHeaderStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '28px'
    };

    const sectionTitleStyleLarge = {
        fontSize: '38px',
        fontWeight: '700',
        color: '#111111'
    };

    const viewAllStyle = {
        fontSize: '18px',
        fontWeight: '600',
        color: '#111111',
        cursor: 'pointer'
    };

    const productGridStyle = {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
        gap: '24px'
    };

    const productCardStyle = {
        background: '#FFFFFF',
        border: '1px solid #EEEEEE',
        borderRadius: '24px',
        padding: '20px',
        transition: 'all 0.3s ease',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
    };

    const discountBadgeStyle = {
        width: '72px',
        height: '36px',
        borderRadius: '12px',
        background: '#FFE9E9',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#FF4D4F',
        fontWeight: '700',
        fontSize: '16px'
    };

    const productImageStyle = {
        width: '100%',
        height: '220px',
        objectFit: 'contain'
    };

    const productTitleStyle = {
        fontSize: '28px',
        fontWeight: '600',
        color: '#111111',
        lineHeight: '38px'
    };

    const productSubtitleStyle = {
        fontSize: '18px',
        color: '#666666'
    };

    const priceRowStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: '6px'
    };

    const currentPriceStyle = {
        fontSize: '32px',
        fontWeight: '700',
        color: '#111111'
    };

    const oldPriceStyle = {
        fontSize: '18px',
        color: '#BBBBBB',
        textDecoration: 'line-through',
        marginLeft: '10px'
    };

    const ratingStyle = {
        fontSize: '18px',
        fontWeight: '600',
        color: '#111111'
    };

    const addToCartButtonStyle = {
        height: '58px',
        borderRadius: '18px',
        border: '1px solid #EAEAEA',
        background: '#FFFFFF',
        fontSize: '20px',
        fontWeight: '600',
        color: '#111111',
        cursor: 'pointer',
        marginTop: '12px'
    };

    const addToCart = (product) => {
        setCartCount((prev) => prev + 1);

        console.log(`${product.title} added to cart`);
    };

    const topDealsProducts = [
        {
            id: 1,
            discount: '-20%',
            title: 'Bose QuietComfort 45',
            subtitle: 'Wireless Headphones',
            price: '$279.00',
            oldPrice: '$349.00',
            rating: '4.6',
            image: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?q=80&w=1200&auto=format&fit=crop'
        },
        {
            id: 2,
            discount: '-15%',
            title: 'Apple Watch Series 9',
            subtitle: 'GPS 41mm',
            price: '$339.00',
            oldPrice: '$399.00',
            rating: '4.7',
            image: 'https://images.unsplash.com/photo-1546868871-7041f2a55e12?q=80&w=1200&auto=format&fit=crop'
        },
        {
            id: 3,
            discount: '-25%',
            title: 'Nike Air Max 270',
            subtitle: 'Men’s Shoes',
            price: '$104.00',
            oldPrice: '$139.00',
            rating: '4.6',
            image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?q=80&w=1200&auto=format&fit=crop'
        },
        {
            id: 4,
            discount: '-20%',
            title: 'Apple AirPods Pro 2',
            subtitle: 'Wireless Earbuds',
            price: '$199.00',
            oldPrice: '$249.00',
            rating: '4.7',
            image: 'https://images.unsplash.com/photo-1606220945770-b5b6c2c55bf1?q=80&w=1200&auto=format&fit=crop'
        },
        {
            id: 5,
            discount: '-18%',
            title: 'Ray-Ban Wayfarer',
            subtitle: 'Sunglasses',
            price: '$114.00',
            oldPrice: '$139.00',
            rating: '4.6',
            image: 'https://images.unsplash.com/photo-1511499767150-a48a237f0083?q=80&w=1200&auto=format&fit=crop'
        }
    ];

    const categorySectionStyle = {
        padding: '0 32px 40px 32px'
    };

    const categoryGridStyle = {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
        gap: '24px'
    };

    const categoryCardStyle = {
        minHeight: '320px',
        borderRadius: '28px',
        overflow: 'hidden',
        position: 'relative',
        padding: '32px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    };

    const categoryTitleStyle = {
        fontSize: '42px',
        fontWeight: '700',
        color: '#111111',
        marginBottom: '18px'
    };

    const categoryDescriptionStyle = {
        fontSize: '20px',
        lineHeight: '32px',
        color: '#555555',
        maxWidth: '260px'
    };

    const categoryButtonStyle = {
        width: '170px',
        height: '56px',
        borderRadius: '18px',
        border: 'none',
        background: '#FFFFFF',
        color: '#111111',
        fontSize: '18px',
        fontWeight: '600',
        cursor: 'pointer',
        marginTop: '28px',
        boxShadow: '0 4px 14px rgba(0,0,0,0.06)'
    };

    const categoryImageStyle = {
        position: 'absolute',
        right: '20px',
        bottom: '10px',
        width: '52%',
        height: '70%',
        objectFit: 'contain'
    };

    const categoryData = [
        {
            id: 1,
            title: 'Electronics',
            description: 'Smartphones, Laptops, Audio & more',
            background: '#EAF2FF',
            image: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?q=80&w=1200&auto=format&fit=crop'
        },
        {
            id: 2,
            title: 'Fashion',
            description: 'Men, Women & Kids Clothing',
            background: '#FFF1F2',
            image: 'https://images.unsplash.com/photo-1483985988355-763728e1935b?q=80&w=1200&auto=format&fit=crop'
        },
        {
            id: 3,
            title: 'Accessories',
            description: 'Watches, Bags, Sunglasses & more',
            background: '#EEFDF5',
            image: 'https://images.unsplash.com/photo-1523170335258-f5ed11844a49?q=80&w=1200&auto=format&fit=crop'
        }
    ];

    const promoBannerContainerStyle = {
        margin: '0 32px 40px 32px',
        minHeight: '320px',
        borderRadius: '32px',
        overflow: 'hidden',
        position: 'relative',
        background: 'linear-gradient(90deg, #0F1115 0%, #171A20 100%)',
        display: 'flex',
        alignItems: 'center',
        padding: '40px 50px'
    };

    const promoContentStyle = {
        position: 'relative',
        zIndex: 2,
        maxWidth: '460px'
    };

    const promoTitleStyle = {
        fontSize: '64px',
        lineHeight: '74px',
        fontWeight: '700',
        color: '#FFFFFF',
        marginBottom: '20px'
    };

    const promoSubtitleStyle = {
        fontSize: '24px',
        lineHeight: '36px',
        color: 'rgba(255,255,255,0.72)',
        marginBottom: '32px'
    };

    const promoButtonStyle = {
        width: '190px',
        height: '60px',
        borderRadius: '18px',
        border: 'none',
        background: '#FFFFFF',
        color: '#111111',
        fontSize: '20px',
        fontWeight: '600',
        cursor: 'pointer'
    };

    const promoImageStyle = {
        position: 'absolute',
        right: '220px',
        bottom: '0',
        width: '38%',
        height: '100%',
        objectFit: 'contain'
    };

    const promoDiscountStyle = {
        position: 'absolute',
        right: '60px',
        top: '50%',
        transform: 'translateY(-50%)',
        width: '180px',
        height: '180px',
        borderRadius: '50%',
        background: '#F7E9D6',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2
    };

    const footerContainerStyle = {
        background: '#FFFFFF',
        borderTop: '1px solid #EEEEEE',
        marginTop: '20px',
        padding: '60px 32px 24px 32px'
    };

    const footerTopStyle = {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: '40px',
        paddingBottom: '50px',
        borderBottom: '1px solid #EEEEEE'
    };

    const footerBrandTitleStyle = {
        fontSize: '58px',
        fontWeight: '700',
        color: '#111111',
        marginBottom: '20px'
    };

    const footerDescriptionStyle = {
        fontSize: '20px',
        lineHeight: '34px',
        color: '#666666',
        marginBottom: '28px',
        maxWidth: '320px'
    };

    const socialIconsStyle = {
        display: 'flex',
        gap: '18px'
    };

    const socialIconStyle = {
        width: '48px',
        height: '48px',
        borderRadius: '14px',
        background: '#F7F7F7',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '20px',
        cursor: 'pointer'
    };

    const footerColumnTitleStyle = {
        fontSize: '28px',
        fontWeight: '700',
        color: '#111111',
        marginBottom: '28px'
    };

    const footerLinkStyle = {
        fontSize: '20px',
        color: '#666666',
        marginBottom: '18px',
        cursor: 'pointer'
    };

    const footerBottomStyle = {
        paddingTop: '30px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '20px'
    };

    const paymentMethodsStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '14px'
    };

    const paymentCardStyle = {
        minWidth: '70px',
        height: '42px',
        borderRadius: '12px',
        background: '#F7F7F7',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '16px',
        fontWeight: '700',
        color: '#111111'
    };

    const scrollTopButtonStyle = {
        width: '56px',
        height: '56px',
        borderRadius: '50%',
        border: '1px solid #DDDDDD',
        background: '#FFFFFF',
        fontSize: '22px',
        cursor: 'pointer'
    };

    const footerSections = {
        shop: ['All Products', 'Top Deals', 'New Arrivals', 'Best Sellers', 'Categories'],
        customer: ['Contact Us', 'Track Your Order', 'Returns & Refunds', 'Shipping Info', 'FAQ'],
        company: ['About Us', 'Careers', 'Blog', 'Privacy Policy', 'Terms & Conditions']
    };

    const bannerSlides = [
        {
            id: 1,
            title: 'Discover Everything You Need',
            subtitle: 'Top brands. Best prices. Fast delivery.',
            badge: 'SUMMER SALE',
            image: 'https://images.unsplash.com/photo-1546435770-a3e426bf472b?q=80&w=1600&auto=format&fit=crop'
        },
        {
            id: 2,
            title: 'Latest Tech Collection',
            subtitle: 'Upgrade your lifestyle with premium devices.',
            badge: 'NEW ARRIVALS',
            image: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?q=80&w=1600&auto=format&fit=crop'
        },
        {
            id: 3,
            title: 'Fashion Trends 2026',
            subtitle: 'Modern fashion collections for everyone.',
            badge: 'TOP DEALS',
            image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?q=80&w=1600&auto=format&fit=crop'
        }
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveSlide((prev) =>
                prev === bannerSlides.length - 1 ? 0 : prev + 1
            );
        }, 4000);

        return () => clearInterval(interval);
    }, []);
    // Sidebar and menu styles
    const menuStyle = {
        height: '48px',
        border: 'none',
        background: 'transparent',
        borderRadius: '14px',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '0 16px',
        fontSize: '16px',
        fontWeight: '500',
        cursor: 'pointer',
        color: '#222222'
    };

    const menuActiveStyle = {
        ...menuStyle,
        background: '#F3F3F3',
        fontWeight: '600'
    };

    const sectionTitleStyle = {
        fontSize: '14px',
        fontWeight: '600',
        color: '#888888',
        marginTop: '12px',
        marginBottom: '4px',
        paddingLeft: '8px'
    };

    const dividerStyle = {
        height: '1px',
        background: '#EEEEEE',
        margin: '12px 0'
    };

    const headerContainerStyle = {
        height: '88px',
        background: '#FFFFFF',
        borderBottom: '1px solid #EEEEEE',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 32px'
    };

    const searchBarStyle = {
        width: '620px',
        height: '56px',
        background: '#F6F6F6',
        borderRadius: '18px',
        border: 'none',
        outline: 'none',
        padding: '0 20px',
        fontSize: '16px',
        color: '#222222'
    };

    const headerMenuStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '32px'
    };

    const headerItemStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#222222',
        cursor: 'pointer'
    };

    const cartBadgeStyle = {
        position: 'absolute',
        top: '-6px',
        right: '-8px',
        width: '18px',
        height: '18px',
        background: '#FF3B30',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#FFFFFF',
        fontSize: '10px',
        fontWeight: '700'
    };



    return (
        <>
            <Helmet>
                <title>
                    Discover the Best Movies, Ratings & Reviews & Where to Watch | FilmFinderPro
                </title>
                <meta
                    name="description"
                    content="Discover the best movies with FilmFinderPro! Get ratings, reviews, and recommendations on top films. Find where to watch your favorite movies now.."
                />
                <meta name="geo.region" content="US" />
                <meta name="geo.placename" content="United States" />
                <link rel="alternate" hrefLang="en-us" href="https://filmfinderpro.com"/>
                <meta
                    name="keywords"
                    content="movies, movie reviews, yts, movie ratings, top movies, top gun maverick, best movies, best movies of all time"
                />
                <link rel="canonical" href="https://filmfinderpro.com" />
                <script type="application/ld+json">
                    {`
                        {
                          "@context": "https://schema.org",
                          "@type": "WebPage",
                          "name": "  Discover the Best Movies, Ratings & Reviews & Where to Watch | FilmFinderPro",
                          "url": "https://filmfinderpro.com",
                          "description": "Discover the best movies with FilmFinderPro! Get ratings, reviews, and recommendations on top films. Find where to watch your favorite movies now..",
                          "mainEntityOfPage": {
                            "@type": "WebPage",
                            "@id": "https://filmfinderpro.com""
                          }
                        }
                        `}
                </script>
            </Helmet>

            <div style={{display: 'flex', minHeight: '100vh', background: '#F8F8F8'}}>
                <div
                    style={{
                        width: '260px',
                        background: '#FFFFFF',
                        padding: '32px 20px',
                        borderRight: '1px solid #EEEEEE',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '24px'
                    }}
                >
                    <div>
                        <h1
                            style={{
                                fontSize: '42px',
                                fontWeight: '700',
                                margin: 0,
                                color: '#111111'
                            }}
                        >
                            Ome
                        </h1>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '12px'
                        }}
                    >
                        <button style={menuActiveStyle}>🏠 Home</button>

                        <div style={sectionTitleStyle}>Categories</div>

                        <button style={menuStyle}>📱 Electronics</button>
                        <button style={menuStyle}>👕 Fashion</button>
                        <button style={menuStyle}>👜 Accessories</button>

                        <div style={dividerStyle}></div>

                        <button style={menuStyle}>🏷️ Deals</button>
                        <button style={menuStyle}>✨ New Arrivals</button>
                        <button style={menuStyle}>🔥 Best Sellers</button>
                        <button style={menuStyle}>🎧 Support</button>
                    </div>
                </div>

                <div style={{flex: 1, display: 'flex', flexDirection: 'column'}}>

                    <div style={headerContainerStyle}>

                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                position: 'relative'
                            }}
                        >
                            <input
                                type="text"
                                placeholder="Search for products, brands and more..."
                                style={searchBarStyle}
                            />

                            <div
                                style={{
                                    position: 'absolute',
                                    right: '20px',
                                    fontSize: '24px',
                                    color: '#222222'
                                }}
                            >
                                🔍
                            </div>
                        </div>

                        <div style={headerMenuStyle}>

                            <div style={headerItemStyle}>
                                👤
                                <span>Account</span>
                            </div>

                            <div style={headerItemStyle}>
                                🤍
                                <span>Wishlist</span>
                            </div>

                            <div
                                style={{
                                    ...headerItemStyle,
                                    position: 'relative'
                                }}
                            >
                                🛒
                                <span>Cart</span>

                                <div style={cartBadgeStyle}>
                                    {cartCount}
                                </div>
                            </div>
                        </div>
                    </div>



                        <ProductListing/>
                        {/*<ProductView/>*/}



                </div>
            </div>



        </>
    );
};

export default Index;
